import { render, staticRenderFns } from "./notice_modal.vue?vue&type=template&id=8b22ed0c&scoped=true"
import script from "./notice_modal.vue?vue&type=script&lang=js"
export * from "./notice_modal.vue?vue&type=script&lang=js"
import style0 from "./notice_modal.vue?vue&type=style&index=0&id=8b22ed0c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b22ed0c",
  null
  
)

export default component.exports